// eslint-disable-next-line max-len
// https://microsoft.sharepoint.com/:w:/r/teams/osg_oss/marketplace/DnA/_layouts/15/Doc.aspx?sourcedoc=%7B07B29EE9-A189-451D-9F70-FC914C4736E0%7D&file=RequestStatus.docx&action=default&mobileredirect=true&cid=78941529-59e8-45ab-ae4f-b62f59ff99d7
export enum ServiceRequestStatus {
  // default, uninitialized value
  Undefined = 0,

  // the value is indeterminable
  Unknown = 1,

  // the value is known to be something other than available on this list
  Other = 2,

  // the request completed successfully
  Success = 3,

  // there was an error processing the request which originated at the caller
  // side. eg. client requesting a piece data which doesn't exist (404) or which
  // the client doesn't have access to (401), client sending a poorly formatted
  // request (400), or client failing to log in/authenticate
  CallerError = 4,

  // there was a communication error while processing the request  for incoming
  // requests it means we failed to send the response back to the caller. eg.
  // client disconnected before we finished sending the response for outgoing
  // requests it means we failed to connect to the dependency service. eg. a
  // timeout when attempting to connect to a service or a DNS resolution error
  TransportError = 5,

  // there was an error while processing the request which was not related to
  // caller or transport errors for incoming requests it means an error in our
  // own code or in a dependency service for outgoing requests it means an
  // error in the service we are calling or its dependency service
  ServiceError = 6,
}
